import { Modal } from '@almbrand/modal';
import { PdfModal } from '@almbrand/pdfmodal';
import { RichText } from '@almbrand/richtext';
import React from 'react';

export interface PreviewModalProps {
	displayAsPdf: boolean;
	data: string;
	handleMessageDownload: () => void;
	onClose: () => void;
}

export const PreviewModal: React.FC<PreviewModalProps> = ({ displayAsPdf, data, handleMessageDownload, onClose }) => {
	return displayAsPdf ? (
		<PdfModal
			pdfSrc={data}
			handleClose={onClose}
			ariaClose='Luk'
			closeButtonTitle='Luk besked'
		/>
	) : (
		<Modal
			handleClose={onClose}
			actionButtonProps={{ title: 'Download', type: 'tertiary', onClick: handleMessageDownload }}
			mode='default'
			mobileVariation='default'
		>
			<RichText description={data} />
		</Modal>
	);
};
